//TODO: strongly type currentOptions
//TODO: refactor spinner of save/delete buttons.   
// Center spinner, don't dim spinner, create a spinner button control with property for [spinner]="model.saving"

import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '../../../../../core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'search-dialog-page',
    templateUrl: './search-dialog-page.component.html'
})
export class SearchDialogPageComponent {
    @Input()
    model = {
        title: '',
        currentOptions: { allowClear: false, allowMultiSelect: false },
        dialogOpen: false
    };

    @Input()
    options = {};

    @Output()
    onAction: EventEmitter<string>;

    ds: DataService;

    constructor(public app: AppService, private ParentInjector: Injector) {
        this.ds = this.ParentInjector.get(DataService);
        this.onAction = new EventEmitter();
    }

    action(actionType: string) {
        this.onAction.emit(actionType); //emits cancel, select
    }
}
